import axios from 'axios';

export const authService = {
    /** Progress Reports */

    getProgressReportsService: (clientId, params) =>
        axios.get(`/clinical/progress-report/client/${clientId}`, { auth: true, params: { ...params } }),

    getProgressReportByIdService: (clientId, params) =>
        axios.get(`/clinical/progress-report/${clientId}`, { auth: true, params: { ...params } }),

    createProgressReportService: (clientId, body) => axios.post(`/clinical/progress-report/${clientId}`, body, { auth: true }),

    editProgressReportService: (id, body) => axios.patch(`/clinical/progress-report/${id}`, body, { auth: true }),

    deleteProgressReportService: (id) => axios.delete(`/clinical/progress-report/${id}`, { auth: true }),

    generatePdfService: (id) => axios.post(`/clinical/progress-report/${id}/generate-pdf`, {}, { auth: true }),

    getProgressReportDownloadUrlService: (id) => axios.post(`/clinical/progress-report/${id}/download-url`, {}, { auth: true }),

    /** End */
};
